
import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {MdbModalRef, MdbModalService} from 'mdb-angular-ui-kit/modal';
import {MdbTabChange} from 'mdb-angular-ui-kit/tabs/tabs.component';
import {ToastrService} from 'ngx-toastr';
import {AppConfigService} from '../../services/config/app-config.service';
import {TokenStorageService} from '../../services/storage/token-storage.service';
import {UserService} from '../../services/user.service';
import {RegistrationPageComponent} from '../registration-page/registration-page.component';
import {Observable} from "rxjs";
import { ChangeDetectorRef } from '@angular/core';


@Component({
    selector: 'app-management-page',
    templateUrl: './management-page.component.html',
    styleUrls: ['./management-page.component.css'],
    standalone: false
})
export class ManagementPageComponent implements OnInit {

  brokerResponse: any;
  adminResponse: any;
  adminBrokerResponse: any;

  brokerData: any;
  adminBrokerData:any;
  internalUserData:any;
  pa: number = 1;
  itemsPerPage: number = 10;
  loading: boolean = false;
  initialLoading: boolean = false;
  institutions: any;
  countries: any;
  editBrokerModalRef: MdbModalRef<BrokerEditModalComponent> | null = null;
  viewModalRef: MdbModalRef<BrokerUserDetailsModalComponent> | null = null;
  registrationModalRef: MdbModalRef<RegistrationPageComponent> | null = null;
  confirmationModalRef: MdbModalRef<ConfirmationModalComponent> | null = null;
  pwdResetModalRef: MdbModalRef<ResetPasswordModalComponent> | null = null;
  isUsersShow: boolean = true;
  filterText = "";
  selectedFilter = 'username';
  filters = [
    {name: 'Username', value: 'username'},
    {name: 'Full Name', value: 'fullName'},
    {name: 'Email', value: 'email'},
    {name: 'Contact No', value: 'contactNo'},
    {name: 'Institution', value: 'institution'},
    {name: 'Company', value: 'company'}
  ];
    filtersforNormalBrokers = [
    {name: 'Username', value: 'username'},
    {name: 'Full Name', value: 'fullName'},
    {name: 'Email', value: 'email'},
    {name: 'Contact No', value: 'contactNo'},
    {name: 'Company', value: 'company'}
  ];
  filtersForInternalUsers = [
    {name: 'Username', value: 'username'},
    {name: 'Full Name', value: 'fullName'},
    {name: 'Email', value: 'email'},
    {name: 'Contact No', value: 'contactNo'},
  ];

  sortOrder = "ascending";
  sortBy = "";

  isUserManagement = false;
  url: string | undefined;

  env: string | null;
  username: string='';
  apis : any;
  role :any;
  normalBrokerData: any;
  normalBrokerResponse: any;
  loadingForBrokerAdmin: boolean = false;
  initialLoadingForBrokerAdmin: boolean = false;
  isAdminBrokerUsersShow: boolean = true;
  brokerAdminResponse : any;
  institution:any;
  internalUserResponse: any;
  showAdminComponents: boolean = false;
  showBrokerComponents: boolean = false;
  showBrokerAdminComponents:boolean=false;
  showInternalUserComponents:boolean=false;
  openAPIEnabled : any;
  embedAPIEnabled : any;
  backOfficeAPIEnabled : any;
  dwmAPIEnabled : any;
  feedAPIEnabled : any;
  secondaryRoles :any;


  constructor(private router: Router,
              public userService: UserService,
              private appConfig: AppConfigService,
              private toastr: ToastrService,
              private modalService: MdbModalService,
              private tokenStorageService: TokenStorageService,
              private cdr: ChangeDetectorRef
  ) {

    this.isUserManagement = this.router.url.includes('/user-management');
    this.env = this.tokenStorageService.getUserEnv();
    if (this.isUserManagement) {
      if(this.env == 'asia'){
        this.url = appConfig.getAsiaConfig?.tradeStreamingUrl;
      } else {
        this.url = appConfig.getMenaConfig?.tradeStreamingUrl;
      }
    }
    this.username = this.tokenStorageService.getUser().username;
    this.role = this.tokenStorageService.getUser().role;
    this.secondaryRoles = this.tokenStorageService.getUser().secondaryRoles;

    this.showAdminComponents = this.role == 'admin';
    this.showBrokerComponents = this.role == 'broker';
    this.showBrokerAdminComponents = this.role =='brokerAdmin';
    this.showInternalUserComponents = this.role =='internalUser';
  }

  ngOnInit(): void {

    this.institutionList();
    this.countryList();
  }


  toggleSortDirection() {
    this.sortOrder = this.sortOrder === 'ascending' ? 'descending' : 'ascending';
    return this.sortOrder;
  }

  openRegistrationModal() {
    this.registrationModalRef = this.modalService.open(RegistrationPageComponent, {
      modalClass: 'modal-lg modal-dialog-centered'
    })
  }

  pageChanged(event: any): void {
    this.pa = event;
    this.loadDetails(1, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);
  }

  pageChangedForAdminBroker(event: any): void {
    this.pa = event;
    this.loadDetails(4, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }

  pageChangedForInternalUser(event: any): void {
    this.pa = event;
    this.loadDetails(5, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }

  pageSizeChanged(entries: number): void {
    this.itemsPerPage = entries;
    this.loadDetails(1, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }


  pageSizeChangedForAdminBroker(entries: number): void {
    this.itemsPerPage = entries;
    this.loadDetails(4, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }
  pageSizeChangedForInternalUser(entries: number): void {
    this.itemsPerPage = entries;
    this.loadDetails(5, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }

    pageChangedForNormalBroker(event: any): void {
    this.pa = event;
    this.loadBrokers(1,this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy, this.tokenStorageService.getUser().institution);
  }

    pageSizeChangedForNormalBroker(entries: number): void {
    this.itemsPerPage = entries;
      this.loadBrokers(1,this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy, this.tokenStorageService.getUser().institution);
    }


  initBrokerData(data: any) {
    this.institutionList();
    var tempData: any = [];
    data.list.forEach((element: any) => {
      var inst;
      this.institutions?.forEach((e: any) => {
        if (e.institutionId == element.institutionId) {
          inst = e.institution
        }
      });

      const roleMapping: { [key: string]: string } = {
        "7": "stockDeposit",
        "8": "stockWithdraw",
        "9": "stockTransfer",
        "10": "topStocks",
        "11": "appUrlIssuerDev",
        "12": "appUrlIssuerQA",
        "13": "appUrlIssuerSandbox",
        "14": "appUrlIssuerAsiaUAT",
        "15": "appUrlIssuerMenaUAT",
        "16": "appUrlIssuerEuropeUAT",
        "17": "appUrlIssuerUSUAT",
        "18": "appUrlIssuerAsiaPROD",
        "19": "appUrlIssuerMenaPROD",
        "20": "appUrlIssuerEuropePROD",
        "21": "appUrlIssuerUSPROD",
        "22": "manageFundingBlock",
      };
      const rolesArray: string[] = element.role?.split(',').map((r: string) => r.trim()) || [];
      const secondaryRoles: string[] = [];

      Object.keys(roleMapping).forEach((roleKey) => {
        if (rolesArray.includes(roleKey)) {
          secondaryRoles.push(roleMapping[roleKey]);
        }
      });

      var temp = {
        id: element.id,
        username: element.username,
        firstName: element.firstName,
        lastName: element.lastName,
        fullName: element.firstName + " " + element.lastName,
        email: element.email,
        institutionId: element.institutionId,
        contactNo: element.contactNo,
        institution: inst,
        countryId: element.countryId,
        profession: element.profession,
        company: element.company,
        region: element.region,
        createdDate: element.createdDate===null ? 'null': element.createdDate,
        openAPIEnabled:element.openAPIEnabled,
        embedAPIEnabled:element.embedAPIEnabled,
        dwmAPIEnabled:element.dwmAPIEnabled,
        backOfficeAPIEnabled:element.backOfficeAPIEnabled,
        feedAPIEnabled:element.feedAPIEnabled,
        secondaryRoles : secondaryRoles
      }
      tempData.push(temp)
    });
    return tempData
  }
  loadDetails(userType: number, pageNo: number, filter:string, filterText:string, sortOrder:string, sortBy:string): void {
    this.loading = true;
    this.cdr.detectChanges();

    this.userService.getSortedFilteredUsersDetails(userType,sortOrder,sortBy,filter,filterText, pageNo, this.itemsPerPage, null).subscribe(
      {
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            if (userType === 1) {
              this.brokerResponse = data;
              this.brokerData = this.initBrokerData(data)
              if (this.brokerResponse.list.length <= 0) {
                this.isUsersShow = false;
              }
            }else if (userType === 4) {
              this.adminBrokerResponse = data;
              this.adminBrokerData = this.initBrokerData(data)
              if (this.adminBrokerResponse.list.length <= 0) {
                this.isUsersShow = false;
              }
            }
            else if (userType === 2) {
              this.adminResponse = data.list;

              if (this.adminResponse.length <= 0) {
                this.isUsersShow = false;
              }
            }else if (userType === 5) {
              this.internalUserResponse = data;
              this.internalUserData = this.initBrokerData(data)

              if (this.internalUserResponse.list.length <= 0) {
                this.isUsersShow = false;
              }
            }


          } else {
            this.toastr.error(data.reason, "Failed to load data");
          }

        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to load data");
        }
      }
    );
  }
  loadPageForBrokerAdmin(userType: number, pageNo: number, institution:any): void {

  this.loadingForBrokerAdmin = true;
    this.cdr.detectChanges();

    this.userService.getSortedFilteredUsersDetails(userType,'','','','', pageNo, this.itemsPerPage, institution).subscribe(
        {
      next: (data) => {
        this.loadingForBrokerAdmin = false;
        this.cdr.detectChanges();

        if (data.status == 'SUCCESS') {

          if (userType === 1) {
            this.normalBrokerResponse = data;
             this.normalBrokerData = this.initBrokerData(data)


            if (this.normalBrokerResponse.list.length <= 0) {
                this.isAdminBrokerUsersShow = false;
              }
          } else if (userType === 4) {
            this.brokerAdminResponse = data.list;
            if (this.brokerAdminResponse.length <= 0) {
              this.isAdminBrokerUsersShow = false;
            }
          }
        } else {
          this.toastr.error(data.reason, "Failed to load data");
        }

      },
      error: (err) => {
        this.loading = false;
        this.toastr.error(err.error.message, "Failed to load data");
      }
    }
  );
}

  loadBrokers(userType: number, pageNo: number, filter:string, filterText:string, sortOrder:string, sortBy:string, institution:any): void {

    this.loadingForBrokerAdmin = true;
    this.cdr.detectChanges();

    this.userService.getSortedFilteredUsersDetails(userType,sortOrder,sortBy,filter,filterText, pageNo, this.itemsPerPage, this.tokenStorageService.getUser().institution).subscribe(
      {
        next: (data) => {
          this.loadingForBrokerAdmin = false;
          this.cdr.detectChanges();

          if (data.status == 'SUCCESS') {

            if (userType === 1) {
              this.normalBrokerResponse = data;
              this.normalBrokerData = this.initBrokerData(data)


              if (this.normalBrokerResponse.list.length <= 0) {
                this.isAdminBrokerUsersShow = false;
              }
            } else if (userType === 4) {
              this.brokerAdminResponse = data.list;
              if (this.brokerAdminResponse.length <= 0) {
                this.isAdminBrokerUsersShow = false;
              }
            }
          } else {
            this.toastr.error(data.reason, "Failed to load data");
          }

        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to load data");
        }
      }
    );
  }
  countryList() {
    this.initialLoading = true;
    this.userService.getCountryList().subscribe((data: any) => {
      this.countries = data.countryList.sort((a: any, b: any) =>
        a.countryName > b.countryName ? 1 : -1
      );
      this.initialLoading = false;
    });
  }

  institutionList() {
    this.initialLoading = true;
    this.userService.getInstitutionList().subscribe((data: any) => {
      this.institutions = data.institutionList.sort((a: any, b: any) =>
        a.institution > b.institution ? 1 : -1
      );

      this.initialLoading = false;
    });
  }

  getAdminUserList(event: MdbTabChange) {
    if (event.index === 0) {
      this.loadDetails(1, this.pa, '', '', '', '');

    }
    else if (event.index === 1) {
      this.loadDetails(4, this.pa, '', '', '', '');


    }
    else if (event.index === 2) {
      this.loadDetails(2, this.pa, '', '', '', '');

    }
    else if (event.index === 3) {
      this.loadDetails(5, this.pa, '', '', '', '');
    }
  }

  getBrokerAdminUserList(event: MdbTabChange) {
    if (event.index === 0) {
      this.loadPageForBrokerAdmin(1, this.pa, this.tokenStorageService.getUser().institution);

    } else if (event.index === 1) {
      this.loadPageForBrokerAdmin(4, this.pa, this.tokenStorageService.getUser().institution);

    }
  }

  openBrokerEditModal(broker: any) {
    this.editBrokerModalRef = this.modalService.open(BrokerEditModalComponent, {
      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        pageNo: this.pa,
        brokerData: broker,
        institutions: this.institutions,
        countries: this.countries
      }
    });

    this.editBrokerModalRef.onClose.subscribe((message: any) => {
      this.loadDetails(1, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

    });
  }

    openNormalBrokerEditModal(broker: any) {
    this.editBrokerModalRef = this.modalService.open(BrokerEditModalComponent, {
      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        pageNo: this.pa,
        normalBrokerData: broker,
        countries: this.countries
      }
    });

    this.editBrokerModalRef.onClose.subscribe((message: any) => {
      this.loadPageForBrokerAdmin(1, this.pa, this.tokenStorageService.getUser().institution);

    });
  }
  openConfirmationModal(broker: any) {
    const institutionObj = this.institutions.filter((institution: any) => {
      return institution.institutionId === broker.institutionId
    });
    this.confirmationModalRef = this.modalService.open(ConfirmationModalComponent, {
      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        id: broker.id,
        firstName: broker.firstName,
        lastName: broker.lastName,
        company: broker.company,
        profession: broker.profession,
        institution: institutionObj[0].institution
      }
    });

    this.confirmationModalRef.onClose.subscribe((message: any) => {
      this.loadDetails(1, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

    });
  }
  openResetPasswordModal(broker: any) {

    this.pwdResetModalRef = this.modalService.open(ResetPasswordModalComponent, {
      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        email: broker.email,
      }
    });

    this.pwdResetModalRef.onClose.subscribe((message: any) => {
      this.loadDetails(1, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

    });
  }


  openNormalBrokerConfirmationModal(broker: any) {
    const institutionObj = this.institutions.filter((institution: any) => {
      return institution.institutionId === broker.institutionId
    });
    this.confirmationModalRef = this.modalService.open(ConfirmationModalComponent, {
      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        id: broker.id,
        firstName: broker.firstName,
        lastName: broker.lastName,
        company: broker.company,
        profession: broker.profession,
        institution: institutionObj[0].institution
      }
    });

    this.confirmationModalRef.onClose.subscribe((message: any) => {
      this.loadPageForBrokerAdmin(1, this.pa,this.tokenStorageService.getUser().institution );

    });
  }
  viewBroker(broker: any) {
    const institutionObj = this.institutions.filter((institution: any) => {
      return institution.institutionId === broker.institutionId
    });

    const countryObj = this.countries.filter((country: any) => {
      return country.countryId === broker.countryId
    });
    this.viewModalRef = this.modalService.open(BrokerUserDetailsModalComponent, {

      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        firstName: broker.firstName,
        lastName: broker.lastName,
        company: broker.company,
        email: broker.email,
        contactNo: broker.contactNo,
        profession: broker.profession,
        userName: broker.username,
        institution: institutionObj[0].institution,
        institutionId: broker.institutionId,
        country: countryObj[0].countryName,
        region: broker.region,
        role: "broker",
      // apis: this.getInstitutionalApiList(broker.institutionId)
        openAPIEnabled:broker.openAPIEnabled,
        embedAPIEnabled:broker.embedAPIEnabled,
        dwmAPIEnabled:broker.dwmAPIEnabled,
        backOfficeAPIEnabled:broker.backOfficeAPIEnabled,
        feedAPIEnabled:broker.feedAPIEnabled,
        secondaryRoles : broker.secondaryRoles
      }
    });
  }

  viewNormalBroker(broker: any) {
    const institutionObj = this.institutions.filter((institution: any) => {
      return institution.institutionId === broker.institutionId
    });
    const countryObj = this.countries.filter((country: any) => {
      return country.countryId === broker.countryId
    });
    this.viewModalRef = this.modalService.open(BrokerUserDetailsModalComponent, {

      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        firstName: broker.firstName,
        lastName: broker.lastName,
        company: broker.company,
        email: broker.email,
        contactNo: broker.contactNo,
        profession: broker.profession,
        userName: broker.username,
        institution: institutionObj[0].institution,
        institutionId: broker.institutionId,
        country: countryObj[0].countryName,
        region: broker.region,
        role: "broker",
     //   apis: this.getInstitutionalApiList(broker.institutionId)
        openAPIEnabled:broker.openAPIEnabled,
        embedAPIEnabled:broker.embedAPIEnabled,
        dwmAPIEnabled:broker.dwmAPIEnabled,
        backOfficeAPIEnabled:broker.backOfficeAPIEnabled,
        feedAPIEnabled:broker.feedAPIEnabled,
        secondaryRoles : broker.secondaryRoles
      }
    });
  }
  viewInternalUser(broker: any) {
    const institutionObj = this.institutions.filter((institution: any) => {
      return institution.institutionId === broker.institutionId
    });
    const countryObj = this.countries.filter((country: any) => {
      return country.countryId === broker.countryId
    });
    this.viewModalRef = this.modalService.open(BrokerUserDetailsModalComponent, {

      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        firstName: broker.firstName,
        lastName: broker.lastName,
       company: broker.company,
        email: broker.email,
        contactNo: broker.contactNo,
        profession: broker.profession,
        userName: broker.username,
       institution: institutionObj[0].institution,
       institutionId: broker.institutionId,
        country: countryObj[0].countryName,
        region: broker.region,
        role: "internalUser",
        openAPIEnabled:broker.openAPIEnabled,
        embedAPIEnabled:broker.embedAPIEnabled,
        dwmAPIEnabled:broker.dwmAPIEnabled,
        backOfficeAPIEnabled:broker.backOfficeAPIEnabled,
        feedAPIEnabled:broker.feedAPIEnabled,
        secondaryRoles : broker.secondaryRoles
    }
    });
  }

  viewAdmin(admin: any) {
    this.viewModalRef = this.modalService.open(BrokerUserDetailsModalComponent, {

      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        firstName: admin.firstName,
        lastName: admin.lastName,
        company: admin.company,
        email: admin.email,
        contactNo: admin.contactNo,
        profession: admin.profession,
        userName: admin.username,
        institution: "",
        country: "",
        region: "",
        role: "admin"
      }
    });
  }
}

@Component({
    selector: 'broker-edit-modal',
    templateUrl: 'broker-edit-page-modal.html',
    styleUrls: ['./management-page.component.css'],
    standalone: false
})
export class BrokerEditModalComponent {
  pageNo: any;
  brokerForm: FormGroup = new FormGroup({
    brokerFullName: new FormControl(''),
    brokerLastName: new FormControl(''),
    brokerCompany: new FormControl(''),
    brokerProfession: new FormControl(''),
    brokerEmail: new FormControl(''),
    brokerCountryCode: new FormControl(''),
    brokerContactNo: new FormControl(''),
    brokerCountry: new FormControl(''),
    brokerUserName: new FormControl(''),
    brokerInstitution: new FormControl(''),
    region: new FormControl(''),
    openAPIEnabled : new FormControl(''),
    embedAPIEnabled : new FormControl(''),
    backOfficeAPIEnabled : new FormControl(''),
    dwmAPIEnabled : new FormControl(''),
    feedAPIEnabled : new FormControl('')
  });
  normalBrokerForm: FormGroup = new FormGroup({
    normalBrokerFullName: new FormControl(''),
    normalBrokerLastName: new FormControl(''),
    normalBrokerCompany: new FormControl(''),
    normalBrokerProfession: new FormControl(''),
    normalBrokerEmail: new FormControl(''),
    normalBrokerCountryCode: new FormControl(''),
    normalBrokerContactNo: new FormControl(''),
    normalBrokerCountry: new FormControl(''),
    normalBrokerUserName: new FormControl(''),
    normalBrokerInstitution: new FormControl(''),
    normalBrokerRegion: new FormControl(''),
    openAPIEnabled : new FormControl(''),
    embedAPIEnabled : new FormControl(''),
    backOfficeAPIEnabled : new FormControl(''),
    dwmAPIEnabled : new FormControl(''),
    feedAPIEnabled : new FormControl('')
  });

  submitted: boolean = false;
  institutions: any;

  countries: any;
  brokerData: any;
  normalBrokerData:any;
  updating: boolean = false;
  user: any;
  instId :any[] = [];
  loadingInstitutionApiData = false;
   apis : any;
   role : any;
   defaultInstitution:any;
   defaultRegion:any;
   selectedFilter:any;
  filterText :any;
  env:any;
  showAdminComponents: boolean = false;
  showBrokerComponents: boolean = false;
  showBrokerAdminComponents:boolean=false;
  showInternalUserComponents:boolean=false;

  professions = [
    "Software Developer",
    "System Architect",
    "DevOps Engineer",
    "Data Engineer",
    "Security Professional",
    "Quality Assurance Engineer",
    "Technical Support Engineer",
    "Product Manager",
    "Compliance Officer",
    "Business Analyst",
    "UI/UX Engineer",
    "Data Scientist",
    "Financial Analyst",
    "Project Manager",
    "Operations Manager"
  ];
  initialLoading: boolean = false;
  allowedCountryCodes:any[]=[];

  constructor(public modalRef: MdbModalRef<BrokerEditModalComponent>, private toastr: ToastrService,
              private userService: UserService, private formBuilder: FormBuilder, private managementPage: ManagementPageComponent, private tokenStorage: TokenStorageService) {
  }

  ngOnInit(): void {
    this.user = this.tokenStorage.getUser();
    this.role = this.user.role;
    this.env = this.tokenStorage.getUserEnv();
    if(this.role == 'admin'){
      this.initializeBrokerForm();
    }else if(this.role =='brokerAdmin'){
      this.initializeNormalBrokerForm();
    }

    this.defaultInstitution = this.user.institution;
    this.defaultRegion = this.user.region;
    this.showAdminComponents = this.role == 'admin';
    this.showBrokerComponents = this.role == 'broker';
    this.showBrokerAdminComponents = this.role =='brokerAdmin';
    this.showInternalUserComponents = this.role =='internalUser';

    this.countryList();
  }

  initializeBrokerForm(): void {
    this.brokerForm = this.formBuilder.group({
      brokerFullName: [this.brokerData?.firstName + ' ' + this.brokerData?.lastName, [Validators.required]],
      brokerCompany: [this.brokerData?.company, [Validators.required]],
      brokerEmail: [this.brokerData?.email, [Validators.required, Validators.email]],
      brokerCountryCode: [this.brokerData?.contactNo, null],
      brokerContactNo: [this.brokerData?.contactNo.split("-")[1], null],
      brokerCountry: [this.brokerData?.countryId, [Validators.required]],
      brokerUserName: [this.brokerData?.username, [Validators.required]],
      brokerInstitution: [this.brokerData?.institutionId, [Validators.required]],
      region: [this.brokerData?.region],
      openAPIEnabled: [this.brokerData.openAPIEnabled,[Validators.required]],
      embedAPIEnabled: [this.brokerData.embedAPIEnabled,[Validators.required]],
      backOfficeAPIEnabled: [this.brokerData.backOfficeAPIEnabled,[Validators.required]],
      dwmAPIEnabled: [this.brokerData.dwmAPIEnabled,[Validators.required]],
      feedAPIEnabled: [this.brokerData.feedAPIEnabled,[Validators.required]]
    });


  }

  initializeNormalBrokerForm(): void {
    this.normalBrokerForm = this.formBuilder.group({
      normalBrokerFullName: [this.normalBrokerData?.firstName + ' ' + this.normalBrokerData?.lastName, [Validators.required]],
      normalBrokerCompany: [this.normalBrokerData?.company, [Validators.required]],
      normalBrokerEmail: [this.normalBrokerData?.email, [Validators.required, Validators.email]],
      normalBrokerCountryCode: [this.normalBrokerData?.contactNo, null],
      normalBrokerContactNo: [this.normalBrokerData?.contactNo.split("-")[1], null],
      normalBrokerCountry: [this.normalBrokerData?.countryId, [Validators.required]],
      normalBrokerUserName: [this.normalBrokerData?.username, [Validators.required]],
      normalBrokerInstitution: [this.user.institution ],
      normalBrokerRegion: [this.normalBrokerData?.region, [Validators.required]],
      openAPIEnabled: [this.normalBrokerData.openAPIEnabled,[Validators.required]],
      embedAPIEnabled: [this.normalBrokerData.embedAPIEnabled,[Validators.required]],
      backOfficeAPIEnabled: [this.normalBrokerData.backOfficeAPIEnabled,[Validators.required]],
      dwmAPIEnabled: [this.normalBrokerData.dwmAPIEnabled,[Validators.required]],
      feedAPIEnabled: [this.normalBrokerData.feedAPIEnabled,[Validators.required]]
    });


  }

  onClickBrokerEdit(): void {
    this.submitted = true;

    if (this.brokerForm.invalid) {
      this.toastr.error('Please fill the form', 'Error');
      return;
    }
    this.updating = true;

    const fullName = this.brokerForm.value.brokerFullName.trim().split(/\s+/);
    const brokerFirstName = fullName[0];
    const brokerLastName = fullName.slice(1).join(' '); // in case there's a middle name

    const {
      brokerCompany,
      brokerProfession,
      brokerEmail,
      brokerCountryCode,
      brokerContactNo,
      brokerCountry,
      brokerUserName,
      brokerInstitution,
      region,
      openAPIEnabled,
      embedAPIEnabled,
      backOfficeAPIEnabled,
      dwmAPIEnabled,
      feedAPIEnabled

    } = this.brokerForm.value;
    this.userService.editProfileDetails(
      brokerFirstName,
      brokerLastName,
      brokerEmail,
      brokerCountryCode.dialCode + '-' + brokerContactNo,
      null,
      brokerCompany,
      brokerCountry,
      brokerUserName,
      brokerInstitution,
      this.user.username,
      region,
      openAPIEnabled == true ? 1 : 0,
      embedAPIEnabled == true ? 1 : 0,
      backOfficeAPIEnabled == true ? 1 : 0,
      dwmAPIEnabled == true ? 1 : 0,
      feedAPIEnabled == true ? 1 : 0
      ).subscribe({
      next: data => {
        this.updating = false;
        if (data.status == 'SUCCESS') {
          this.closeModal();
          this.toastr.success('Broker user updated successfully', 'Success');
        } else {
          this.toastr.error(data.reason, 'Broker user update failed');
        }
      },
      error: err => {
        this.updating = false;
        this.toastr.error(err.error.message, 'Broker user update failed');
      }
    });
  }

  onClickNormalBrokerEdit(): void {
    this.submitted = true;

    if (this.normalBrokerForm.invalid) {
      this.toastr.error('Please fill the form', 'Error');
      return;
    }
    this.updating = true;
    const {
      normalBrokerFirstName,
      normalBrokerLastName,
      normalBrokerCompany,
      normalBrokerProfession,
      normalBrokerEmail,
      normalBrokerCountryCode,
      normalBrokerContactNo,
      normalBrokerCountry,
      normalBrokerUserName,
      normalBrokerInstitution,
      normalBrokerRegion
    } = this.normalBrokerForm.value;
    this.userService.editNormalBrokerProfileDetails(
      normalBrokerFirstName,
      normalBrokerLastName,
      normalBrokerEmail,
      normalBrokerCountryCode.dialCode + '-' + normalBrokerContactNo,
      null,
      normalBrokerCompany,
      normalBrokerCountry,
      normalBrokerUserName,
      normalBrokerInstitution,
      this.user.username,
      normalBrokerRegion).subscribe({
      next: data => {
        this.updating = false;
        if (data.status == 'SUCCESS') {
          this.closeModal();
          this.toastr.success('Broker user updated successfully', 'Success');
        } else {
          this.toastr.error(data.reason, 'Broker user update failed');
        }
      },
      error: err => {
        this.updating = false;
        this.toastr.error(err.error.message, 'Broker user update failed');
      }
    });
  }

  closeModal(): void {
    this.modalRef.close();
    if(this.user.role == 'admin'){
      this.managementPage.loadDetails(1, this.pageNo, '','' , '', '');


    } else if(this.user.role == 'brokerAdmin'){
      this.managementPage.loadPageForBrokerAdmin(1, this.pageNo, this.user.institution)

    }

  }


  get formBrokerControl(): { [key: string]: AbstractControl } {
    return this.brokerForm.controls;
  }
  get formNormalBrokerControl(): { [key: string]: AbstractControl } {
    return this.normalBrokerForm.controls;
  }

  countryList() {
    this.initialLoading = true;
    this.userService.getCountryList().subscribe((data: any) => {
      this.countries = data.countryList.sort((a: any, b: any) =>
        a.countryName > b.countryName ? 1 : -1
      );
      this.allowedCountryCodes = this.countries.map((country: any) =>
        country.countryCode.toLowerCase()
      );
      this.initialLoading = false;
    });
  }
}

@Component({
    selector: 'broker-user-details-modal',
    templateUrl: 'broker-user-details-modal.html',
    styleUrls: ['./management-page.component.css'],
    standalone: false
})
export class BrokerUserDetailsModalComponent {

  firstName: string | null = null;
  lastName: string | null = null;
  company: string | null = null;
  email: string | null = null;
  contactNo: string | null = null;
  profession: string | null = null;
  userName: string | null = null;
  institution: string | null = null;
  country: string | null = null;
  region: string | null = null;
  role:string | null = null;
  apis: any;
  openAPIEnabled : any;
  embedAPIEnabled : any;
  backOfficeAPIEnabled : any;
  dwmAPIEnabled : any;
  feedAPIEnabled : any;
  secondaryRoles : any;

  constructor(public modalRef: MdbModalRef<BrokerUserDetailsModalComponent>) {
  }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalRef.close();
  }

}

@Component({
    selector: 'broker-confirmation-modal',
    templateUrl: 'broker-confirmation-modal.html',
    styleUrls: ['./management-page.component.css'],
    standalone: false
})
export class ConfirmationModalComponent {

  id: number | -1 = -1;
  loading: boolean = false;
  firstName: string | null = null;
  lastName: string | null = null;
  company: string | null = null;
  profession: string | null = null;
  institution: string | null = null;
  env:any;

  constructor(public modalRef: MdbModalRef<ConfirmationModalComponent>,
              private toastr: ToastrService,
              private userService: UserService,
              public cdr: ChangeDetectorRef,
              private tokenStorage: TokenStorageService) {
  }

  ngOnInit(): void {
    this.env = this.tokenStorage.getUserEnv();
  }

  onDeletePress() {
    this.loading = true;
    this.cdr.detectChanges(); // Manually trigger change detection

    this.userService.deleteBrokerUser(this.id).subscribe(
      {
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            this.toastr.success("Broker deleted successfully");
            this.modalRef.close();
          } else {
            this.toastr.error(data.reason, "Failed to delete user");
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to delete user");
          this.cdr.detectChanges();
        }
      }
    );
  }

  closeModal(): void {
    this.modalRef.close();
  }

}


@Component({
    selector: 'broker-reset-password-modal.html',
    templateUrl: 'broker-reset-password-modal.html',
    styleUrls: ['./management-page.component.css'],
    standalone: false
})
export class ResetPasswordModalComponent {

  loading: boolean = false;
  email: string | null = null;
  form: FormGroup = new FormGroup({});
  submitted: boolean = false;
  user: any;

  constructor(public modalRef: MdbModalRef<ResetPasswordModalComponent>,
              private toastr: ToastrService,
              private userService: UserService,
              private formBuilder: FormBuilder,
              private router: Router) {
  }

  ngOnInit() {
    // this.initializeForm();
  }

  // initializeForm(): void {
  //   this.form = this.formBuilder.group(
  //     {
  //       email: [
  //         '',
  //         [Validators.required]
  //       ]
  //     }
  //   );
  // }

  onClickSubmit(email:any) {
    this.submitted = true;
    console.log("**********************************************************")
    console.log(email)
    if (this.form.invalid) {
      this.toastr.error('Please enter registered email', 'Reset password failed');
      return;
    }
    this.loading = true;
    this.userService.resetPassword(email).subscribe(
      {
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            this.router.navigate(['/dashboard/user-management']);
            this.toastr.success('Password reset successfully', 'Success');
          } else {
            this.toastr.error(data.reason, 'Reset password failed');
          }
        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, 'Reset password failed');
        }
      }
    );
  }

  get formControl(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  closeModal(): void {
    this.modalRef.close();
  }

}
